export const SEARCH_DISPLAY_NAME = "Search";
